import submitImageToStorage from './submitImageToStorage';

export const getURLForCustomArtwork = async (artworkState, folderName) => {
    const artworkObject = {};
    if (
        artworkState.leftArtwork.leftImage === artworkState.rightArtwork.rightImage &&
        artworkState.leftArtwork.displayName === 'Custom Artwork'
    ) {
        artworkObject['both'] = await submitImageToStorage(
            folderName,
            artworkState.leftArtwork.leftImage,
            'both'
        );
    } else {
        if (artworkState.leftArtwork.displayName === 'Custom Artwork') {
            artworkObject['left_artwork'] = await submitImageToStorage(
                folderName,
                artworkState.leftArtwork.leftImage,
                'left_artwork'
            );
        }
        if (artworkState.rightArtwork.displayName === 'Custom Artwork') {
            artworkObject['right_artwork'] = await submitImageToStorage(
                folderName,
                artworkState.rightArtwork.rightImage,
                'right_artwork'
            );
        }
    }
    return artworkObject;
};
